(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["decibel-home-hero-carousel"] && !Shopify.designMode) return;
  try {
    (function(){
  function initCarousel(root){
    var carousels=root.querySelectorAll('[data-dc-hero-carousel]:not([data-dc-ready])');
    carousels.forEach(function(carousel){
      carousel.setAttribute('data-dc-ready','true');
      var slides=Array.prototype.slice.call(carousel.querySelectorAll('.dc-hero-carousel__slide'));
      var caption=carousel.querySelector('[data-dc-hero-caption]');
      var link=carousel.querySelector('[data-dc-hero-link]');
      var linkLabel=carousel.querySelector('[data-dc-hero-link-label]');
      var count=carousel.querySelector('[data-dc-hero-count]');
      var prev=carousel.querySelector('[data-dc-hero-prev]');
      var next=carousel.querySelector('[data-dc-hero-next]');
      var toggle=carousel.querySelector('[data-dc-hero-toggle]');
      if(slides.length<2){
        if(carousel.querySelector('.dc-hero-carousel__controls')) carousel.querySelector('.dc-hero-carousel__controls').hidden=true;
        return;
      }
      var index=0;
      var timer=null;
      var userPaused=false;
      var firstImage=slides[0].querySelector('img');
      var firstImageReady=!firstImage || (firstImage.complete && firstImage.naturalWidth>0);
      var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function pad(n){return String(n).padStart(2,'0');}
      function render(nextIndex){
        index=(nextIndex+slides.length)%slides.length;
        slides.forEach(function(slide,i){
          var active=i===index;
          slide.classList.toggle('is-active',active);
          slide.setAttribute('aria-hidden',active?'false':'true');
          slide.tabIndex=active?0:-1;
        });
        var activeSlide=slides[index];
        if(caption) caption.textContent=activeSlide.getAttribute('data-dc-caption')||'';
        if(link){
          link.href=activeSlide.href;
          if(linkLabel) linkLabel.textContent=activeSlide.getAttribute('data-dc-link-label')||'View project';
        }
        if(count) count.textContent=pad(index+1)+' / '+pad(slides.length);
      }
      function stop(){if(timer){window.clearInterval(timer);timer=null;}}
      function start(){
        stop();
        if(reduced||userPaused||!firstImageReady||document.hidden) return;
        timer=window.setInterval(function(){render(index+1);},4000);
      }
      if(prev) prev.addEventListener('click',function(){render(index-1);start();});
      if(next) next.addEventListener('click',function(){render(index+1);start();});
      if(toggle) toggle.addEventListener('click',function(){
        userPaused=!userPaused;
        toggle.textContent=userPaused?'Play':'Pause';
        toggle.setAttribute('aria-label',userPaused?'Play project rotation':'Pause project rotation');
        if(userPaused) stop(); else start();
      });
      carousel.addEventListener('mouseenter',stop);
      carousel.addEventListener('mouseleave',start);
      carousel.addEventListener('focusin',stop);
      carousel.addEventListener('focusout',function(event){
        if(!carousel.contains(event.relatedTarget)) start();
      });
      if(firstImage && !firstImageReady){
        firstImage.addEventListener('load',function(){firstImageReady=true;start();},{once:true});
      }
      document.addEventListener('visibilitychange',function(){if(document.hidden) stop(); else start();});
      render(0);
      if(reduced&&toggle){toggle.textContent='Play';toggle.setAttribute('aria-label','Play project rotation');userPaused=true;}
      start();
    });
  }
  function boot(){initCarousel(document);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  if(!window.__dcHeroCarouselSectionBound){
    window.__dcHeroCarouselSectionBound=true;
    document.addEventListener('shopify:section:load',function(event){initCarousel(event.target);});
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["decibel-inquiry-tracking"] && !Shopify.designMode) return;
  try {
    (() => {
    const PENDING_KEY = 'decibel:pending-project-inquiry:v1';
    const MAX_AGE = 30 * 60 * 1000;
    const TYPE_KEYS = ['architecture', 'retail', 'furniture', 'installations', 'production', 'other'];
    let context;
    let sending = false;

    function knownSource(value) {
      return value && Object.prototype.hasOwnProperty.call(context.sources, value) ? value : 'direct';
    }

    function sourceFromReferrer() {
      try {
        const referrer = new URL(document.referrer);
        if (referrer.origin !== window.location.origin) return 'direct';
        const view = referrer.searchParams.get('view');
        if (referrer.pathname.endsWith('/pages/custom-fabrication') && ['architectural-fabrication', 'retail-fabrication', 'why-lfam', 'selected-press', 'projects'].includes(view)) return view;
        return Object.keys(context.sources).find(key => context.sources[key] === referrer.pathname) || 'direct';
      } catch (_) { return 'direct'; }
    }

    function arrivalSource() {
      const source = knownSource(new URL(window.location.href).searchParams.get('project_source'));
      return source !== 'direct' ? source : sourceFromReferrer();
    }

    function liveStorefront() {
      return !context.designMode && window.Shopify?.theme?.role === 'main' && !window.Shopify?.designMode;
    }

    function analyticsAllowed() {
      try { return liveStorefront() && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
      catch (_) { return false; }
    }

    function clearPending() {
      try { window.sessionStorage.removeItem(PENDING_KEY); } catch (_) { /* Form delivery never depends on storage. */ }
    }

    function readPending() {
      try {
        const pending = JSON.parse(window.sessionStorage.getItem(PENDING_KEY));
        if (!pending || !/^db-[a-f0-9]{32}$/.test(pending.id) || !Number.isFinite(pending.at) || Date.now() - pending.at > MAX_AGE || pending.at > Date.now()) {
          clearPending();
          return null;
        }
        return pending;
      } catch (_) { return null; }
    }

    function makeId() {
      try {
        return 'db-' + Array.from(window.crypto.getRandomValues(new Uint8Array(16)), b => b.toString(16).padStart(2, '0')).join('');
      } catch (_) { return ''; }
    }

    function connectLinks() {
      const source = knownSource(context.source);
      if (source === 'direct' || !context.contactPath) return;
      document.querySelectorAll('a[href]').forEach(link => {
        try {
          const destination = new URL(link.getAttribute('href'), window.location.origin);
          if (destination.origin !== window.location.origin || destination.pathname.replace(/\/$/, '') !== context.contactPath.replace(/\/$/, '')) return;
          destination.searchParams.set('project_source', source);
          link.setAttribute('href', destination.pathname + destination.search + destination.hash);
        } catch (_) { /* Leave unusual links untouched. */ }
      });
    }

    function bindForm() {
      const form = document.querySelector('form.decibel-inquiry__form');
      if (!form || form.dataset.inquiryBound) return;
      form.dataset.inquiryBound = 'true';
      const sourceInput = form.querySelector('[data-inquiry-source]');
      const idInput = form.querySelector('[data-inquiry-id]');
      if (!sourceInput || !idInput) return;
      const source = arrivalSource();
      const id = makeId();
      sourceInput.value = context.sources[source];
      if (id) idInput.value = id;
      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        // Native Shopify submission, spam protection and delivery are unchanged.
        // Only a non-PII, short-lived success-correlation record is stored, with analytics permission.
        clearPending();
        if (!id || !analyticsAllowed()) return;
        const type = form.querySelector('[data-inquiry-type]')?.selectedOptions[0]?.dataset.typeKey;
        const pending = { id, source, type: TYPE_KEYS.includes(type) ? type : 'unspecified', at: Date.now() };
        try { window.sessionStorage.setItem(PENDING_KEY, JSON.stringify(pending)); } catch (_) { /* Send the form normally. */ }
      });
    }

    function publishSuccess() {
      if (sending || !document.querySelector('[data-decibel-inquiry-success]') || !analyticsAllowed()) return;
      const pending = readPending();
      if (!pending || typeof window.Shopify?.analytics?.publish !== 'function') return;
      const source = knownSource(pending.source);
      sending = true;
      try {
        window.Shopify.analytics.publish('decibel:project_inquiry_submitted', {
          inquiry_id: pending.id,
          source_key: source,
          source_page: context.sources[source],
          project_type: TYPE_KEYS.includes(pending.type) ? pending.type : 'unspecified',
          form_id: 'start_a_project',
          qualification_status: 'unreviewed'
        });
        clearPending();
      } catch (_) {
        sending = false;
      }
    }

    function init() {
      const element = document.getElementById('DecibelInquiryContext');
      if (!element) return;
      try { context = JSON.parse(element.textContent); } catch (_) { return; }
      connectLinks();
      bindForm();
      const status = document.querySelector('[data-decibel-inquiry-errors], [data-decibel-inquiry-success]');
      if (status) status.focus();
      if (document.querySelector('[data-decibel-inquiry-errors]')) clearPending();
      publishSuccess();
      if (liveStorefront() && !window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], error => { if (!error) publishSuccess(); });
      }
    }

    document.addEventListener('visitorConsentCollected', () => {
      if (!context) return;
      if (!analyticsAllowed()) clearPending();
      else publishSuccess();
    });
    document.addEventListener('shopify:section:load', init);
    window.addEventListener('load', () => { if (context) publishSuccess(); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
